package com.patronat.top.client.presentation.auth

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.atoms.AppButton
import com.patronat.top.ui.atoms.ButtonType
import com.patronat.top.ui.theme.AppImages
import com.patronat.top.ui.theme.BodyLarge
import com.patronat.top.ui.theme.MineShaft600
import com.patronat.top.ui.theme.OnboardingTitleText
import com.patronat.top.ui.theme.Primary600
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import top.clientapp.generated.resources.Res
import top.clientapp.generated.resources.auth_continue_without_account
import top.clientapp.generated.resources.auth_get_started_description
import top.clientapp.generated.resources.auth_get_started_title
import top.clientapp.generated.resources.auth_login_by_phone
import top.clientapp.generated.resources.auth_register_by_phone

@Composable
internal fun ClientGetStartedContent(
    onRegisterByPhoneClick: () -> Unit,
    onLoginByPhoneClick: () -> Unit,
    onContinueWithoutAccountClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    Column(
        modifier = modifier
            .fillMaxSize()
            .widthIn(max = 420.dp)
            .padding(horizontal = 24.dp),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Spacer(modifier = Modifier.height(82.dp))

        ClientGetStartedMedia()

        Spacer(modifier = Modifier.height(42.dp))

        Text(
            text = stringResource(Res.string.auth_get_started_title),
            style = OnboardingTitleText
        )

        Spacer(modifier = Modifier.height(14.dp))

        Text(
            text = stringResource(Res.string.auth_get_started_description),
            style = BodyLarge.copy(
                color = MineShaft600,
                textAlign = TextAlign.Center
            ),
            modifier = Modifier.widthIn(max = 302.dp)
        )

        Spacer(modifier = Modifier.weight(1f))

        AppButton(
            text = stringResource(Res.string.auth_register_by_phone),
            onClick = onRegisterByPhoneClick,
            modifier = Modifier.fillMaxWidth(),
            type = ButtonType.BrownFilled
        )

        Spacer(modifier = Modifier.height(20.dp))

        AppButton(
            text = stringResource(Res.string.auth_login_by_phone),
            onClick = onLoginByPhoneClick,
            modifier = Modifier.fillMaxWidth(),
            type = ButtonType.Black
        )

        Spacer(modifier = Modifier.height(14.dp))

        TextButton(onClick = onContinueWithoutAccountClick) {
            Text(
                text = stringResource(Res.string.auth_continue_without_account),
                style = BodyLarge.copy(
                    color = Primary600,
                    fontWeight = FontWeight.SemiBold
                )
            )
        }

        Spacer(modifier = Modifier.height(24.dp))
    }
}

@Composable
private fun ClientGetStartedMedia(
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .fillMaxWidth()
            .height(236.dp),
        contentAlignment = Alignment.Center
    ) {
        Image(
            painter = painterResource(AppImages.SignUp1),
            contentDescription = null,
            contentScale = ContentScale.Crop,
            modifier = Modifier
                .align(Alignment.BottomStart)
                .size(132.dp)
                .clip(RoundedCornerShape(12.dp))
        )

        Column(
            modifier = Modifier
                .align(Alignment.TopEnd)
                .offset(x = (-20).dp),
            verticalArrangement = Arrangement.spacedBy(14.dp)
        ) {
            Image(
                painter = painterResource(AppImages.SignUp2),
                contentDescription = null,
                contentScale = ContentScale.Crop,
                modifier = Modifier
                    .size(110.dp)
                    .clip(RoundedCornerShape(12.dp))
            )

            Image(
                painter = painterResource(AppImages.SignUp3),
                contentDescription = null,
                contentScale = ContentScale.Crop,
                modifier = Modifier
                    .size(110.dp)
                    .clip(RoundedCornerShape(12.dp))
            )
        }
    }
}
